/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_EditInputs */

const en_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const fr_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const es_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const it_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica`)
};

const nl_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerken`)
};

const pl_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

const fi_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkaa`)
};

const da_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger`)
};

const sv_cover_letters_edit = /** @type {(inputs: Cover_Letters_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redigera`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Cover_Letters_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_edit = /** @type {((inputs?: Cover_Letters_EditInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_EditInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_edit(inputs)
	if (locale === "fr") return fr_cover_letters_edit(inputs)
	if (locale === "es") return es_cover_letters_edit(inputs)
	if (locale === "it") return it_cover_letters_edit(inputs)
	if (locale === "nl") return nl_cover_letters_edit(inputs)
	if (locale === "pl") return pl_cover_letters_edit(inputs)
	if (locale === "fi") return fi_cover_letters_edit(inputs)
	if (locale === "da") return da_cover_letters_edit(inputs)
	if (locale === "sv") return sv_cover_letters_edit(inputs)
	return en_cover_letters_edit(inputs)
});